export default __webpack_public_path__ + "static/media/product_8.54052b51.webp";